import React from 'react';
import { ROVING_ITEM_ATTR, onRovingKeyDown, rovingTabIndex } from './rovingFocus';

// Presentational row of preset pills. Date math lives in the caller
// (DateRangePicker) — this only renders `presets` and reports clicks.
const DatePresetTabs = ({ presets, activeLabel, onSelect, label = 'Date range preset' }) => {
  const activeIndex = presets.findIndex((preset) => preset.label === activeLabel);

  return (
    <div
      role="radiogroup"
      aria-label={label}
      onKeyDown={onRovingKeyDown}
      className="flex flex-wrap items-center gap-2"
    >
      {presets.map((preset, index) => {
        const active = preset.label === activeLabel;
        return (
          <button
            key={preset.label}
            type="button"
            role="radio"
            aria-checked={active}
            tabIndex={rovingTabIndex(active, index, activeIndex)}
            {...{ [ROVING_ITEM_ATTR]: '' }}
            onClick={() => onSelect(preset)}
            className={`h-8 max-md:h-11 max-md:min-w-11 px-2.5 rounded-lg text-xs leading-4 border transition-colors whitespace-nowrap focus:outline-none focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-focus ${
              active
                ? 'bg-brandFill border-brandFill text-white font-medium'
                : 'bg-surface border-line text-ink-muted hover:text-ink'
            }`}
          >
            {preset.label}
          </button>
        );
      })}
    </div>
  );
};

export default DatePresetTabs;
